module.exports = __webpack_public_path__ + "static/bannerNovo3Mobile-afedb92378746657700b0cad22780410.jpg";